<template>
	<div class="editor-panels">
		 <el-container class="editor-panels__container">
			 <el-header style="height: 30px;">
				 <ul class="operate">
					 <el-tooltip  content="发送文件" placement="top">
						   <li v-show="isCanSend(index_infos.channel,'file')">
								<el-upload
									action=""
									:http-request="(file) => uploadEvent(file,'file')"
									:show-file-list="false"
									accept=".doc,.docx,.xls,.xlsx,.zip,.rar,.pdf">
									<svg-icon icon-class="im-upload-file"></svg-icon>
								</el-upload>
						   </li>
					 </el-tooltip>
					 <el-tooltip  content="发送图片" placement="top">
					 	<li v-show="isCanSend(index_infos.channel,'image')">
					 		<el-upload
								action=""
								:http-request="(file) => uploadEvent(file,'image')"
								:show-file-list="false"
								accept=".png,.jpeg,.jpg,.bmp">
								<svg-icon icon-class="im-upload-img"></svg-icon>
							</el-upload>
					 	</li>
					 </el-tooltip>
					 <el-tooltip  content="客服转接" placement="top">
					 	<li @click="openTransferViewer"><svg-icon icon-class="im-upload-transfer"></svg-icon></li>
					 </el-tooltip>
					 <el-tooltip  content="快捷话术" placement="top" >
					 	<li class="fast-words" @click="openFastwordViewer"><svg-icon icon-class="im-fast-words"></svg-icon></li>
					 </el-tooltip>
				 </ul>
			 </el-header>
			 <el-main class="textarea">
				 <el-input
					:rows="8"
					type="textarea"
					placeholder='按“/”唤醒快捷话术'
					v-model.trim="editorText"
					clearable
					resize="none"
					v-paste="pasteImage"
					v-dragPasteImage="dragPasteImage"
					@keydown.native="keydownEvent($event)"
					@input="inputEvent($event)"
				 ></el-input>
			 </el-main>
			 <el-footer class="footer" style="height: 40px;">
				 <ul>
					 <li @click="onEnd">结束会话</li>
					 <li> <el-button @click="openHistoryView" type="text" :disabled="!historyBtnDisabled">聊天历史</el-button></li>
				 </ul>
				 <template>
					 <el-button type="primary" @click="sendEvent">发送</el-button>
				 </template>
			 </el-footer>
		 </el-container>
		 <!-- 图片查看器 -->
		 <EditorImageView
		   ref="imageViewer"
		   v-model="imageViewer.isShow"
		   :source="imageViewer.source"
		   :uploadStatus="imageViewer.uploadStatus"
		   @confirm="confirmUploadImage"
		 />
		 <!-- 文件查看器 -->
		 <EditorFileView
		   ref="fileViewer"
		   v-model="fileViewer.isShow"
		   :source="fileViewer.source"
		   :uploadStatus="fileViewer.uploadStatus"
		   @confirm="confirmUploadFile"
		 />
		 <!-- 图文查看器 -->
		 <EditorNewsView
		   ref="newsViewer"
		   v-model="newsViewer.isShow"
		   :source="newsViewer.source"
		   @confirm="confirmNews"
		 />
		 <!-- 卡片查看器 -->
		 <EditorMiniprogramView
		   ref="miniprogrampageViewer"
		   v-model="miniprogrampageViewer.isShow"
		   :source="miniprogrampageViewer.source"
		   @confirm="confirmMiniprogram"
		 />
		 <!-- 关键字搜索 -->
		 <KeywordView 
			v-if="keywordView.isShow"
			ref="keywordView" 
			v-model="keywordView.isShow"
			:keyword="keywordView.keyword"
			@confirm="confirmKeyword"
		/>
	</div>
</template>

<script>
	import { getPasteImgs, getDragPasteImg} from '@/utils/uploadEditor';
	import EditorImageView from './editorImageView';
	import EditorFileView from './editorFileView';
	import EditorNewsView from './editorNewsView';
	import EditorMiniprogramView from './editorMiniprogramView';
	import KeywordView from './keywordView';
	import {compressImg} from '@/utils/functions.js';
	import { imChatService } from '@/utils/mixins';
	import { findTalk,getImServiceAuth,isCanSend } from '@/utils/imService';
	import { mapState } from 'vuex';
	export default {
		mixins:[imChatService],
		props:['historyBtnDisabled'],
		components:{
			EditorImageView,
			EditorFileView,
			EditorNewsView,
			EditorMiniprogramView,
			KeywordView
		},
		computed:{
			...mapState({
				index_name:state => state.imChatService.index_name,
				index_infos:state => state.imChatService.index_infos
			})
		},
		watch: {
		  index_name(val) {
		    this.editorText = this.getDraftText(val)
		  },
		  editorText(value){
			  this.$emit('keyboard-event', value);
		  }
		},
		data(){
			return {
				editorText: '',// 当前编辑的内容
				imageViewer:{
					isShow: false,
					source: null,
					uploadStatus:false
				},
				fileViewer:{
					isShow: false,
					source: null,
					uploadStatus:false
				},
				keywordView:{
					isShow:false,
					source: null,
					keyword:''
				},
				newsViewer:{
					isShow:false,
					source: null,
				},
				miniprogrampageViewer:{
					isShow:false,
					source: null,
				},
				sendtime: 0,// 上次发送消息的时间
				interval: 1000,// 发送间隔时间（默认1秒）
				
			}
		},
		methods:{
			isCanSend,
			openHistoryView(){
				this.$emit('handleEvent',{
					type:'history',
					show:true
				});
			},
			openFastwordViewer(){
				this.$emit('handleEvent',{
					type:'fastword',
					show:true
				});
			},
			openTransferViewer(){
				this.$emit('handleEvent',{
					type:'transfer',
					show:true
				});
			},
			onEnd(){
				let that = this;
				this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
					type:`坐席主动发起结束会话`,
					content:`sessionId:${this.index_name}`
				})
				if(getImServiceAuth('1008')){
					this.$api.judgeImserviceToSaveCommunication(this.index_name).then(res => {
						this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
							type:`当前会话${this.index_name}结束是否已保存沟通小结`,
							content:`响应:${JSON.stringify(res)}`
						})
						if(!res.data) return this.$message.error('请先保存沟通小结');
						this.toEndApi(this.index_name)
						
					})
				}else {
					this.toEndApi(this.index_name)
				}
			},
			toEndApi(session_id){
				this.$confirm("该操作不可恢复","确认要结束当前会话吗？", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true,
					customClass: "confirm-element-model",
					callback:(action,instance) => {
						if(action == 'confirm') {
							this.$api.toEndImServiceDialogue(session_id).then(res => {
								this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
									type:`坐席主动发起结束会话响应`,
									content:`响应:${JSON.stringify(res)}`
								})
								if(res.errcode != 0) return;
								this.$store.commit('imChatService/REMOVE_TALK_ITEM', session_id);
								this.$store.commit('imChatService/DELETE_CUSTOMERINFO_PANELS',session_id);
							})
						}else {
							this.$message.info('取消结束')
						}
					}
				})
			},
			// 读取对话编辑草稿信息
			getDraftText(session_id) {
			  return findTalk(session_id)?.draft_text || ''
			},
			confirmKeyword(source){
				switch (source.type){
					case 'text':
						this.editorText = source.content
						break;
					case 'image':
						this.imageViewer.isShow = true
						this.imageViewer.source = source;
						this.imageViewer.uploadStatus = true;
						break;
					case 'file':
						this.fileViewer.isShow = true
						this.fileViewer.source = source;
						this.fileViewer.uploadStatus = true;
						break;
					case 'news':
						this.newsViewer.isShow = true;
						this.newsViewer.source = source;
						break;
					case 'miniprogrampage':
						this.miniprogrampageViewer.isShow = true;
						this.miniprogrampageViewer.source = source;
						break;
				}
			},
			// 发送小卡片
			confirmMiniprogram(){
				const {brand, channel, session_id, skillGroup} = this.$store.state.imChatService.index_infos;
				let ref = this.$refs['miniprogrampageViewer'];
				ref.loading = false;
				ref.closeBox();  
				this.sendMessagetoApi({
					brand:brand,
					channel:channel,
					session_id:session_id,
					skillGroup:skillGroup,
					type:'miniprogrampage',
					miniProgram:this.miniprogrampageViewer.source.miniProgram,
				}).then(() => {
					
				})
			},
			// 发送图文
			confirmNews(){
				const {brand, channel, session_id, skillGroup} = this.$store.state.imChatService.index_infos;
				let ref = this.$refs['newsViewer'];
				ref.loading = false;
				ref.closeBox();  
				this.sendMessagetoApi({
					brand:brand,
					channel:channel,
					session_id:session_id,
					skillGroup:skillGroup,
					type:'news',
					attachment:this.newsViewer.source.attachment,
					data: this.newsViewer.source
				}).then(() => {
					
				})
			},
			// 发送图片
			confirmUploadImage(){
				this.uploadFileToApi(this.imageViewer.source,'imageViewer','image');
			},
			// 发送文件
			confirmUploadFile(){
				this.uploadFileToApi(this.fileViewer.source,'fileViewer','file');
			},
			/* 发送图片或者文件 */
			uploadFileToApi(file,refBox,msgType){
				let ref = this.$refs[refBox];
				const {brand, channel, session_id, skillGroup} = this.$store.state.imChatService.index_infos;
				if(this[refBox]['uploadStatus']){
					ref.loading = false;
					ref.closeBox();  
					this.sendMessagetoApi({
						brand:brand,
						channel:channel,
						session_id:session_id,
						skillGroup:skillGroup,
						type:msgType,
						attachment:file.attachment
					}).then(() => {
						
					})
					return;
				}
				const formData = new FormData()
				formData.append('file', file);
				 const { brandIdentify, userId } = this.$store.state.user.userInfo;
				 this.$api.uploadImServiceFile(`/livechat/msg/upload/${brandIdentify}/${userId}`,formData)
				 .then(res => {
						ref.loading = false;
						if(res.errcode !=0 ) return;
						ref.closeBox();  
						this.sendMessagetoApi({
							brand:brand,
							channel:channel,
							session_id:session_id,
							skillGroup:skillGroup,
							type:msgType,
							attachment:res.data
						}).then(() => {
							
						})
				 })
			},
			async uploadEvent(params,type){
				if(this.beforeUpload(params.file,type)) {
					let result_files = type == 'image' ? await compressImg(params.file) : params.file;
					if(type == 'image'){
						this.imageViewer.isShow = true;
						this.imageViewer.uploadStatus = false;
						this.imageViewer.source = result_files;
						return;
					}
					this.fileViewer.isShow = true
					this.fileViewer.source = result_files;
					this.fileViewer.uploadStatus = false;
				}
			},
			beforeUpload(file,type){
				let isTrue = false;
				let uploadType = this.imageType;
				const isLimitSize = file.size / 1024 / 1024 < 20;
				const image_tips = 'png|jpeg|jpg|PNG|JPEG|JPG';
				const file_tips = 'xlsx|xls|csv|docx|doc|rar|pdf|zip';
				switch (type){
					case 'image':
						isTrue = /\.(png|jpeg|jpg|PNG|JPEG|JPG)$/.test(file.name);
						break;
					case 'file':
						isTrue = /\.(xlsx|xls|csv|docx|doc|rar|pdf|zip)$/.test(file.name);
						break;
					default:
						isTrue = true;
						break;
				}
				if(!isTrue) {
					this.$message.error(`上传只能是${type == 'image' ? image_tips : file_tips}格式`);
					return false
				}
				if(!isLimitSize) {
					this.$message.error("上传文件大小不能超过20M")
					return false
				}
				return true
			},
			inputEvent(e){
				this.$emit('keyboard-event', e);
				this.keywordView.keyword = e;
			},
			keydownEvent(e){
				if (e.keyCode == 13 && this.editorText == '') {
				     e.preventDefault()
				}
				if(e.keyCode == 191) {
					this.keywordView.isShow = true;
					e.preventDefault();
					return;
				}
				// 回车发送消息
				if (e.keyCode == 13 && e.shiftKey == false && this.editorText != '') {
				  let currentTime = new Date().getTime();
				  if (this.sendtime > 0) {
				    // 判断 1秒内只能发送一条消息
				    if (currentTime - this.sendtime < this.interval) {
				      e.preventDefault();
				      return false;
				    }
				  }
				
				  this.sendEvent();
				  e.preventDefault();
				}
			},
			sendEvent(){
				if(this.editorText != ''){
					let currentTime = new Date().getTime();
					if (this.sendtime > 0) {
					  // 判断 1秒内只能发送一条消息
					  if (currentTime - this.sendtime < this.interval) {
					    return false;
					  }
					}
					this.$emit('send', this.editorText);
					this.editorText = '';
					this.sendtime = currentTime;
					return;
				}
				this.$message.warning("发送消息不能为空")
				
			},
			async pasteImage(e){
				let files = getPasteImgs(e);
				if (files.length == 0) return;
				this.imageViewer.isShow = true
				this.imageViewer.source =  await compressImg(files[0]);
			},
			async dragPasteImage(e){
				let files = getDragPasteImg(e)
				if (files.length == 0) return
				this.imageViewer.isShow = true
				this.imageViewer.source =  await compressImg(files[0]);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.editor-panels {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 9px 0 20px;
		.svg-icon {
			font-size: 22px;
		}
		ul {
			li {
				list-style: none;
			}
		}
		.operate {
			width: 100%;
			display: flex;
			position: relative;
			li {
				margin-right: 20px;
				cursor: pointer;
				&.fast-words {
					position: absolute;
					right: 0;
					margin-right: 0;
				}
			}
		}
		.textarea {
			padding: 0;
			::v-deep {
				.el-textarea,
				.el-textarea__inner {
				  outline: none;
				  border: none;
				  font-size: 14px;
				  color: #3c4353;
				}
			}
		}
		.footer {
			display: flex;
			font-size: 14px;
			justify-content: space-between;
			> ul {
				display: flex;
				align-items: center;
				color: #6c7e91;
				cursor: pointer;
			}
			::v-deep {
				.el-button--text {
					color: #4882C0;
					padding: 0;
					margin-left: 17px;
				}
				.el-button.is-disabled{
					color: #C0C4CC;
				}
				.el-button--primary{
					width: 84px;
					height: 32px;
					background: #0f81fb;
					border-radius: 4px;
					display: flex;
					justify-content: center;
					align-items: center;
					span {
					  font-size: 14px;
					}
				}
			}
		}
	}
</style>